import { createContext, useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import { ItemStatusDto } from '@app/constants';

export const MappingsContext = createContext<Mappings>({
  userItemStatuses: undefined,
  noteTypes: undefined,
  areUserItemStatusesLoading: false,
  configurations: {
    isNativeLogin: false,
    isSSOLogin: false,
    isStackMapEnabled: false,
    libraryLocationMap: {
      library: '',
      location: '',
    },
    configurationsQuery: undefined,
  },
});

export interface ConfigurationsValues {
  isNativeLogin: boolean;
  isSSOLogin: boolean;
  isStackMapEnabled: boolean;
  libraryLocationMap: {
    library: string;
    location: string;
  };
}

interface Configurations {
  configurationsQuery?: UseQueryResult;
}

interface NoteType {
  active: boolean;
  labelKey: string;
}

export interface NoteTypesDto {
  noteTypesForDisplay: NoteType[];
}

export type NoteTypesTransformedDto = Record<string, NoteType>;

export interface Mappings {
  areUserItemStatusesLoading: boolean;
  configurations: Configurations & ConfigurationsValues;
  userItemStatuses?: ItemStatusDto;
  noteTypes?: NoteTypesTransformedDto;
}

export const useMappingsContext = (): Mappings => {
  return useContext(MappingsContext);
};
